import axios from 'axios';
import config from '../common/config';

/**
 * Service for authentication API operations
 */
class AuthService {
  constructor() {
    this.baseURL = config.getRootURL();
    this.axiosInstance = this.createAxiosInstance();
  }

  /**
   * Create configured axios instance
   * @returns {AxiosInstance} Configured axios instance
   */
  createAxiosInstance() {
    const instance = axios.create({
      baseURL: this.baseURL,
      withCredentials: true
    });

    // Request interceptor để thêm authorization header
    instance.interceptors.request.use(
      (config) => {
        const token =
          localStorage.getItem('AccessToken') ||
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('AccessToken='))
            ?.split('=')[1];

        if (token) {
          config.headers.Authorization = token;
        }

        config.headers['Content-Type'] = 'application/json';
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    return instance;
  }

  /**
   * Change user password
   * @param {Object} passwordData - Password data
   * @param {string} passwordData.password - Current password
   * @param {string} passwordData.new_password - New password
   * @param {string} passwordData.confirmed_new_password - Confirmed new password
   * @returns {Promise<Object>} API response
   */
  async changePassword(passwordData) {
    try {
      const response = await this.axiosInstance.post(
        '/gd/v3/change_password',
        passwordData
      );

      return response.data;
    } catch (error) {
      const apiError = error.response?.data?.errors?.[0];
      const errorMessage =
        apiError?.message || error.message || 'Không thể đổi mật khẩu';
      const field = apiError?.detail?.field || apiError?.field;

      const enhancedError = new Error(errorMessage);
      enhancedError.field = field;
      enhancedError.raw = apiError;
      throw enhancedError;
    }
  }
}

// Create singleton instance
const authService = new AuthService();

export default authService;
